import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// Modals
import { AlertasModales } from '../../../../helpers/alertasModales';
// Servicios
import { EmpleadosServicio } from '../../../../services/empleado.service';
import { TimerObservable } from 'rxjs/observable/TimerObservable';

@Component({
  selector: 'app-perfil-empleado',
  templateUrl: './perfil-empleado.component.html',
  styleUrls: ['./perfil-empleado.component.css']
})
export class PerfilEmpleadoComponent implements OnInit {
  datosEmpleado: any;
  loaded = false;
  private q = 'xxNbTQzPUXwe3JBZVJfjz2FIou4YTc2FQ31J5eJwFs4';
  hasQuestions = false;
  hasAccessToken = true;

  constructor(
    public empleadoService: EmpleadosServicio,
    private route: ActivatedRoute,
    private router: Router,
    private modals: AlertasModales) {
    this.route.params.subscribe(params => {
      this.cargarDatosEmpleado(params.id);
    });
  }

  ngOnInit() {
    if (this.empleadoService.datosEmpleado.tipo_empleado !== 3
      && !this.empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == 32).length) {
      this.hasAccessToken = false;
    }
  }

  private initParams(): void {
    this.route.queryParams.subscribe(params => {
      if (params.q && params.q === this.q && this.datosEmpleado.hasQuestions === 0) {
        this.preguntasSecretas();
      }
    });
  }

  private cargarDatosEmpleado(ID): void {
    this.empleadoService.cargarEmpleadoPorId(ID).subscribe(res => {
      // tslint:disable-next-line:max-line-length
      if (res && String(res.usuario).toLowerCase() !== 'root' && (this.empleadoService.datosEmpleado.tipo_empleado === 3 || this.empleadoService.datosEmpleado.tipo_empleado === 1 && res.tipo_empleado !== 3)) {
        this.datosEmpleado = res;
        setTimeout(() => this.loaded = true, 1);
        this.initParams();
      } else {
        this.router.navigate(['/404']);
      }
    });
  }

  agregarEmpleadoRuta() {
    this.modals.asignarRutaEmpleadosNgbModal(this.datosEmpleado, this.datosEmpleado.rutas_asignadas)
    .then((res: any) => {
      if (res) {
        this.cargarDatosEmpleado(this.datosEmpleado.ID_EMPLEADO);
      }
    });
  }

  agregarCompania() {
    this.modals.asignarCompaniaEmpleadosNgbModal(this.datosEmpleado, this.datosEmpleado.companias_asignadas)
    .then((res: any) => {
      if (res) {
        this.cargarDatosEmpleado(this.datosEmpleado.ID_EMPLEADO);
      }
    });
  }

  empleadoEnMapa() {
    const markers = [{
      lat: this.datosEmpleado.lat,
      lng: this.datosEmpleado.lng,
      nombreCompleto: this.datosEmpleado.nombre + ' ' + this.datosEmpleado.apellido,
      foto_perfil: this.datosEmpleado.foto_perfil
    }];
    this.modals.vistaMapaNgbModal(markers);
  }

  editarPass() {
    this.modals.vistaEditarPassNgbModal(this.datosEmpleado.ID_EMPLEADO);
  }

  accesoCliente() {
    this.modals.accesoClienteNgbModal(this.datosEmpleado);
  }

  preguntasSecretas() {
    this.modals.preguntasSecretasNgbModal()
    .then(res => {
      if (res) {
        this.datosEmpleado.hasQuestions = 3;
        this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-check');
      }
    });
  }

  agregarPagina() {
    this.modals.asignarPaginaEmpleadosNgbModal(this.datosEmpleado, this.datosEmpleado.paginas_asignadas)
    .then((res: any) => {
      if (res) {
        this.cargarDatosEmpleado(this.datosEmpleado.ID_EMPLEADO);
      }
    });
  }

  agregarPermiso() {
    this.modals.asignarPermisoEmpleadosNgbModal(this.datosEmpleado, this.datosEmpleado.permisos_asignados)
    .then((res: any) => {
      if (res) {
        this.cargarDatosEmpleado(this.datosEmpleado.ID_EMPLEADO);
      }
    });
  }

  generarToken() {
    this.modals.generarTokenEmpleadoNgbModal(`${this.datosEmpleado.nombre} ${this.datosEmpleado.apellido}`, this.datosEmpleado.ID_EMPLEADO);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/empleado/perfil/perfil-empleado/perfil-empleado.component.ts